// A non-colour differentiator for "this option is selected" (InterestDropdown, AllocationDropdown).
// Spec 5.1 marks the selected state NOT SPECIFIED; #EEF3EC is already the drawn HOVER fill (spec
// 4.3), so reusing it for selected would make the two collide the moment a user hovers any option --
// see README.md ("dropdown selected state") for the measured defect this replaces.
export default function SelectedCheckmark() {
  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" aria-hidden="true">
      <path d="M1 4L4 7L9 1" stroke="#4CBC18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
